import React from 'react';
import './History.css';

const History = () => {
  return (
    <section className="history">
      <div className="history-container">
        <div className="history-content">
          <h2>How we started</h2>
          <div className="history-text">
            <p>
              After nearly a decade of teaching computer science, we saw a frustrating trend: high schools are not doing enough to prepare students for college, internships, and full-time jobs.
            </p>
            <p>
              In a world where AI is rapidly automating the how, the true differentiator will be those who master the what. That's why we created Pike Teams—a high-intensity arena where the nation's top computer science students don't just code;<strong> students compete to build products that matter.</strong>
            </p>
            <p>
              For six weeks, our students work in elite teams, solving real problems in their communities with guidance from top industry experts. It's pressure-packed, it's fast, and it's the best way to learn.
            </p>
			 <p>
              Pike Teams was created to fill the gap in coding programs for students who want to push beyond the classroom and into professional-grade development.
            </p>
            <p>
              Think you have what it takes? Prove it.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default History; 